var map = {
	"./WBPhome.png": 27,
	"./WBPshould.png": 28,
	"./WPlogo.png": 86,
	"./WPlogo2.png": 87,
	"./WPlogo3.png": 88,
	"./poolImage1.jpeg": 89,
	"./poolImage2.jpeg": 90,
	"./poolImage3.jpg": 91
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;


//////////////////
// WEBPACK FOOTER
// ./src/pics ^\.\/.*$
// module id = 12
// module chunks = 0